export default function Gallery() {
  const photos = [
    {
      alt: "Remplacement gond de fenêtre Strasbourg par technicien DF PRO",
      src: "https://static.readdy.ai/image/60b7a1bdc124301cce40c5bb19c672c9/4556278079676d5ae98b246f855d6da5.jpeg",
      w: 600,
      h: 400,
      seq: "gond1",
    },
    {
      alt: "Technicien ajustant une paumelle à Schiltigheim, Bas-Rhin",
      src: "https://static.readdy.ai/image/60b7a1bdc124301cce40c5bb19c672c9/65a7cc3cb6b8e3ce4f320a786437b00f.jpeg",
      w: 600,
      h: 400,
      seq: "gond2",
    },
    {
      alt: "Gond usé démonté prêt au remplacement à Haguenau",
      src: "https://static.readdy.ai/image/60b7a1bdc124301cce40c5bb19c672c9/d4eb334fa6c3ec07d88434ab6f63fc88.jpeg",
      w: 600,
      h: 400,
      seq: "gond3",
    },
    {
      alt: "Nouveau gond installé sur fenêtre PVC à Strasbourg",
      src: "https://static.readdy.ai/image/60b7a1bdc124301cce40c5bb19c672c9/02f88e78deab8fa956020fc4b08694de.jpeg",
      w: 600,
      h: 400,
      seq: "gond4",
    },
    {
      alt: "Technicien DF PRO vérifiant l'alignement à Illkirch",
      src: "https://static.readdy.ai/image/60b7a1bdc124301cce40c5bb19c672c9/77a12784605cc455b206bd0338fab5f1.jpeg",
      w: 600,
      h: 400,
      seq: "gond5",
    },
    {
      alt: "Fenêtre réparée avec gonds neufs dans le Bas-Rhin",
      src: "https://static.readdy.ai/image/60b7a1bdc124301cce40c5bb19c672c9/a5678743fe9ccf4d4061d6534d54e38d.jpeg",
      w: 600,
      h: 400,
      seq: "gond6",
    },
  ];

  return (
    <section className="bg-white py-10 md:py-14 lg:py-16">
      <div className="w-full px-4 md:px-8 lg:px-12 max-w-[1280px] mx-auto">
        <div className="mb-10 md:mb-14">
          <p className="font-serif italic text-plum-dark text-sm md:text-base mb-3">
            Galerie de réalisations
          </p>
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-plum">
            Nos <span className="font-serif italic">interventions</span> sur gond et paumelle
          </h2>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {photos.map((p) => (
            <div
              key={p.seq}
              className="rounded-2xl overflow-hidden border border-rose-200 bg-rose-50"
            >
              <img
                src={
                  p.src
                    ? p.src
                    : `https://readdy.ai/api/search-image?query=${encodeURIComponent(p.prompt)}&width=${p.w}&height=${p.h}&seq=${p.seq}&orientation=landscape`
                }
                alt={p.alt}
                className="w-full h-[260px] object-cover object-top"
              />
              <div className="px-4 py-3">
                <p className="text-xs text-plum-dark/60 italic">[PHOTO]</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}